import { safeDefine } from "../../registration/safe-define.js";
import { FullscreenButtonElement } from "../../ui/fullscreen-button/element.js";
//#region src/define/ui/fullscreen-button.ts
safeDefine(FullscreenButtonElement);
//#endregion
